import { api } from "@/lib/api";

const KEY = "ee_sid";
let currentPath = typeof window !== "undefined" ? window.location.pathname : "/";
let lastTick = Date.now();
let started = false;

function getSid() {
  let s = localStorage.getItem(KEY);
  if (!s) {
    s = (crypto.randomUUID && crypto.randomUUID()) || String(Date.now()) + Math.random();
    localStorage.setItem(KEY, s);
  }
  return s;
}

export async function trackPageview(path) {
  currentPath = path;
  lastTick = Date.now();
  try {
    await api.post("/track/pageview", {
      session_id: getSid(),
      path,
      title: document.title,
      referrer: document.referrer || "",
      screen: `${window.innerWidth}x${window.innerHeight}`,
      language: navigator.language || "",
    });
  } catch (_) {
    /* tracking must never break the UI */
  }
}

export async function trackEvent(type, meta = {}) {
  try {
    await api.post("/track/event", { session_id: getSid(), path: currentPath, type, ...meta });
  } catch (_) {
    /* tracking must never break the UI */
  }
}

function flush(useBeacon) {
  const now = Date.now();
  const delta = Math.round((now - lastTick) / 1000);
  lastTick = now;
  if (delta <= 0) return;
  const payload = { session_id: getSid(), path: currentPath, delta };
  if (useBeacon && navigator.sendBeacon) {
    navigator.sendBeacon(
      `${api.defaults.baseURL}/track/heartbeat`,
      new Blob([JSON.stringify(payload)], { type: "application/json" }),
    );
  } else {
    api.post("/track/heartbeat", payload).catch(() => {});
  }
}

export function startHeartbeat() {
  if (started) return;
  started = true;
  setInterval(() => {
    if (document.visibilityState === "visible") flush(false);
  }, 15000);
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") flush(true);
  });
  window.addEventListener("pagehide", () => flush(true));
}
